import { Controller } from "@hotwired/stimulus"

// This is a simple transposition from legacy js. It could be rewritten in a
// more stimulus-y way.
// Connects to data-controller="color-picker"
export default class extends Controller {
  connect() {
    this.setupColorField = this.setupColorField.bind(this)
    this.bindFields = this.bindFields.bind(this)
    this.colorChange = this.colorChange.bind(this)
    this.addError = this.addError.bind(this)
    this.clearError = this.clearError.bind(this)
    this.$colorFields = $("[data-color-picker]")
    this.setupColorField()
  }

  setupColorField() {
    this.$colorFields.addClass("color-hex")
    return $.each(this.$colorFields, (idx, field) => {
      const $field = $(field)
      $field.wrap($("<div />").addClass("color-picker-box"))
      const $colorSwatch = $("<input type='color' />")
        .addClass("color-picker")
        .val($(field).val())
      $colorSwatch.insertBefore($(field))
      return this.bindFields($field, $colorSwatch)
    })
  }

  bindFields($hex, $swatch) {
    $swatch.on("change", () => this.colorChange($swatch.val(), $hex, $swatch))
    return $hex.on("change", () => this.colorChange($hex.val(), $hex, $swatch))
  }

  colorChange(color, $hex, $swatch) {
    if (!/(^#[0-9A-F]{6}$)/i.test(color)) {
      this.addError($hex)
      return
    }
    this.clearError($hex)
    $swatch.val(color)
    $hex.val(color)
    const update = $hex.data("color-update")
    if (update && $(update).length) {
      return $(update).css("background-color", color)
    }
  }

  addError($field) {
    const $formBox = $field.closest(".form-input")
    $formBox.addClass("field_with_errors")
    const $error = $("<div />")
      .addClass("alert alert-error")
      .text("should be an RGB hex code, e.g. #FFCCAA")
    const $errorBox = $formBox.find(".alert-error")
    if ($errorBox.length) {
      return $errorBox.replaceWith($error)
    } else {
      return $formBox.append($error)
    }
  }

  clearError($field) {
    const $formBox = $field.closest(".form-input")
    $formBox.removeClass("field_with_errors")
    return $formBox.find(".alert-error").remove()
  }
}
